/**
 * HPC eligibility comes from either a cohort (its dates win, so manual dates
 * are cleared) or manual start/end dates. Turning HPC off clears both.
 */
export const toHpcEligibilityInput = (data: {
  hasHpcEligibility?: boolean | null;
  cohortId?: string | null;
  hpcEligibilityStart?: string | null;
  hpcEligibilityEnd?: string | null;
}) => {
  const cohortId = data.hasHpcEligibility ? data.cohortId || null : null;
  const useManualDates = data.hasHpcEligibility && !cohortId;
  return {
    cohortId,
    hpcEligibilityStart: useManualDates
      ? (data.hpcEligibilityStart ?? null)
      : null,
    hpcEligibilityEnd: useManualDates ? (data.hpcEligibilityEnd ?? null) : null,
  };
};
